import { breakpoints, Inline } from '@etg/wings';
import { css, cx } from '@eti/styles';
import type { ReactNode } from 'react';

const inlineStyles = css`
  & > :first-child {
    align-self: center;
    padding: 16px 0;
    text-align: end;
    width: 55px;

    @media (min-width: ${breakpoints._768}) {
      width: 70px;
    }
  }

  & > :last-child {
    align-self: center;
    flex: 1;
    padding: 16px 0;
  }
`;

interface TimelineRowProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

const TimelineRow = ({ children, className, 'data-testid': dataTestId }: TimelineRowProps) => (
  <Inline className={cx(inlineStyles, className)} data-testid={dataTestId}>
    {children}
  </Inline>
);

export default TimelineRow;
